export default __webpack_public_path__ + "8c8269c2c2bc72db16d884b2b844e577.jpg";